import BaseProxy from './Proxy';

export default class SubstoreOrderSummaryProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/order/summary', parameters);
  }

  find(subscriptionTemplateId, orderCallId) {
    return this.submit('get', `${this.endpoint}/${subscriptionTemplateId}/${orderCallId}`);
  }
}
